import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { SafetyEquipmentType } from '@api/models/enums/SafetyEquipmentType';
import { EntityState } from '@api/models/enums/EntityState';
import { SafetyEquipmentDto } from '@api/models/invitation/SafetyEquipmentDto';
import { safetyEquipmentService } from '@api/services/services';

type State = BaseType<SafetyEquipmentDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    type: SafetyEquipmentType.Owned,
    stateChangeEnabled: true,
    state: EntityState.Active,
  },
};

export const safetyEquipmentSlice = baseSlice({
  name: 'safetyEquipment',
  initialState,
});

export const selectSafetyEquipmentState = (state: RootState) => state.safetyEquipment.state;
export const selectSafetyEquipment = (state: RootState) => state.safetyEquipment.data;
export const safetyEquipmentActions = safetyEquipmentSlice.actions;

export const getSafetyEquipment = (safetyEquipmentId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return safetyEquipmentService.getById(safetyEquipmentId);
  };

  getItem({
    dispatch,
    actions: safetyEquipmentActions,
    getData: handleGetData,
  });
};
